<ng-container *transloco="let t; prefix: 'organizations.detailPage.riskAnalysisDeliveryTab.documents.tableColumns'">
  <div class="b-document-actions">
    <aml-button
      [variant]="ButtonVariantMap.subtle"
      [iconOnly]="true"
      [icon]="IconNameMap.download"
      [ariaLabel]="t('download')"
      nz-tooltip
      [nzTooltipTitle]="t('download')"
      (buttonClicked)="download()"
    />

    @if (canOfferDelete()) {
      <span
        class="b-document-actions__delete"
        nz-tooltip
        [nzTooltipTitle]="isLastRiskAnalysis() ? t('deleteDisabledLastRiskAnalysis') : t('delete')"
      >
        <aml-button
          [variant]="ButtonVariantMap.subtle"
          [iconOnly]="true"
          [icon]="IconNameMap.trash"
          [ariaLabel]="isLastRiskAnalysis() ? t('deleteDisabledLastRiskAnalysis') : t('delete')"
          [disabled]="isDeleteDisabled()"
          (buttonClicked)="delete()"
        />
      </span>
    }
  </div>
</ng-container>
